import { Editor } from '@tiptap/react';
import { memo } from 'react';

import { type EditorToolbarItem } from './editorActions';
import ToolbarButton from './ToolbarButton';
import { useToolbarState } from './useToolbarState';

interface EditorToolbarProps {
  editor: Editor;
  items: EditorToolbarItem[];
}

const EditorToolbar = memo(function EditorToolbar({
  editor,
  items,
}: EditorToolbarProps) {
  const toolbarState = useToolbarState(editor, items);

  return (
    <div className="flex flex-wrap gap-x-0.5 border-b border-gray-200 p-2 align-middle">
      {toolbarState.map(({ item, active, disabled }) => (
        <ToolbarButton
          key={item}
          editor={editor}
          item={item}
          active={active}
          disabled={disabled}
        />
      ))}
    </div>
  );
});

export default EditorToolbar;
